<div>
  <h3 translate="bookings.title"></h3>

  <app-item-to-book-selection [items]="items"
    [crtLang]="crtLang"
  (selectItem)="selectItemToDisplayInCalendar($event)"></app-item-to-book-selection>

  @if (isExploitant) {
    <div class="row">
      <div class="col-12">
        <label class="form-label" for="searchCustomer" translate="bookings.searchBooking"></label>
        <input class="form-control" id="searchCustomer" name="searchCustomer" type="text"
          #searchCustomer
          [ngbTypeahead]="search"
          pattern="{{ textInputPattern }}"
          placeholder="{{ 'bookings.placeholder.searchBooking' | translate }}">
        </div>
      </div>
    }

    @if (calendarOptions) {
      <full-calendar class="mt-4"
        #fullcalendar
      [options]="calendarOptions"></full-calendar>
    }
  </div>

  <ng-template #eventPopover let-event="event">
    @if (event.extendedProps.booking.reservationType === ReservationType.Booking
      && (isExploitant || (event.extendedProps.booking.customerId && event.extendedProps.booking.customerId === customerId))) {
      <h6>{{ event.extendedProps.booking | firstAndLastname }}</h6>
    } @else {
      <h6 translate="bookings.blocked"></h6>
    }

    <p>{{ event.start  | date: 'HH:mm' }} - {{ event.end  | date: 'HH:mm' }} </p>

    <p>
      @if (event.extendedProps.booking.reservationType === ReservationType.Booking) {
        <span>
          <strong translate="bookings.calendar.tooltip.itemToBook"></strong>
        </span>
      }
      @if (event.extendedProps.booking.reservationType === ReservationType.Blocking) {
        <span>
          <strong translate="bookings.calendar.tooltip.itemBlocked"></strong>
        </span>
      }
      <br/>
      <span>{{ event.extendedProps.item }}</span>
    </p>

    @if (isExploitant && event.extendedProps.booking.comment) {
      <p>
        <span><strong translate="bookings.calendar.tooltip.comment"></strong></span><br/>
        <span>{{ event.extendedProps.booking.comment }}</span>
      </p>
    }
  </ng-template>

  <ng-template #itemPopover let-resource="resource">
    <div>
      <div class="popover-resource">
        <h6>{{ resource.title }}</h6>
        <div class="text-pre-wrap">{{ resource.extendedProps.description }}</div>
      </div>
    </div>
  </ng-template>
